import axios from 'axios';
import _orderBy from 'lodash.orderby';
import Vue from 'vue';
import zenscroll from 'zenscroll';
import Errors from '../classes/errors';
import {
    checkCCM19Consent,
    checkOneTrustConsent,
    handleCloseDropdownOnBlur,
    setCaptchaEuScript,
} from '../utils';

Vue.component('contact-form-component', {
    props: {
        siteHandle: {
            value: String,
        },
        stores: {
            value: Array,
        },
        brandstoreResultAmount: {
            value: Number,
        },
        sharpspringEndpointId: {
            value: String,
        },
        captchaEuPublicKey: {
            value: String,
        },
        isCaptchaEuEnabled: {
            value: Boolean,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            requestType: 'private',
            requestIndex: 0,
            countryHandle: '',
            internalCountryHandle: '',
            frBrandStoreHandle: '',
            selected: '',
            selectedBrandStore: '',
            selectedFrBrandStore: '',

            frBrandStores: {
                martinique: 'MG Martinique (97232 Le Lamentin)',
                guadeloupe: 'MG Guadeloupe (97122 Baie-Mahault)',
                guyane: 'MG Guyane (97324 Cayenne Cedex)',
                mayotte: 'MG Mayotte (97 600 Mamoudzou)',
            },

            dropdownCountry: null,
            dropdownSubject: null,
            dropdownFrStore: '',
            dropdownFrStoreValue: '',

            // Brandstore search visibility
            isBrandstoreSearchVisible: false,
            isFranceCarDealerVisible: false,
            isGermanyCarDealerVisible: false,

            isNumberValid: true,
            isSwitchButtonVisible: true,
            isNoBrandstoreSelected: false,
            isVinNumberVisible: false,
            isCeeCountrySelected: false,

            ceeCountries: [
                'Hungary',
                'Croatia',
                'Slovenia',
                'Serbia',
                'Czech Republic',
                'Slovakia',
                'North Macedonia',
                'Poland',
                'Romania',
                'Greece',
                'Montenegro',
                'Bosnia and Herzegovina',
                'Albania',
                'Kosovo',
            ],
            beluxCountries: [
                'mgMotorsBelgiumNl',
                'mgMotorsBelgiumFr',
                'mgMotorsLuxembourgFr',
            ],
        };
    },

    created() {
        const form = document.getElementById('contactForm');
        if (!form) return;

        form.reset();
    },

    computed: {
        orderedStores: function () {
            return _orderBy(this.stores, 'title');
        },
        isCompanyInputVisible: function () {
            return this.requestType === 'business';
        },
        isSubmitLoading: function () {
            return this.submitting ? 'button--loading' : '';
        },
        toggleMainFormErrorClass() {
            return Object.keys(this.errors.errors).length !== 0
                ? 'main-form-error--errors'
                : '';
        },
    },

    watch: {
        countryHandle() {
            this.showPlanNl = false;
            this.selectedBrandStore = null;
            this.dropdownStore = null;
        },

        selected(value) {
            this.isBrandstoreSearchVisible =
                this.handleToggleBrandstoreSearchVisibility(value);
            this.isFranceCarDealerVisible =
                this.siteHandle === 'mgMotorsFrance' &&
                value === 'want-contact-from-dealer';
            this.isGermanyCarDealerVisible =
                this.siteHandle === 'mgMotorsGermany';

            if (
                this.siteHandle === 'default' &&
                this.ceeCountries.includes(this.dropdownCountry)
            ) {
                this.isVinNumberVisible = [
                    'aftersales-service',
                    'accessories',
                ].includes(value);
            }

            if (this.siteHandle === 'mgMotorsPortugal') {
                this.isVinNumberVisible = ['aftersales-service'].includes(
                    value,
                );
            }

            if (this.beluxCountries.includes(this.siteHandle)) {
                this.isVinNumberVisible = ['aftersales-service'].includes(
                    value,
                );
            }
        },
        requestType(requestTypeValue) {
            this.handleCompanyNameRequiredLabel(requestTypeValue);
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        if (this.siteHandle !== 'default') {
            this.countryHandle = this.siteHandle;
        }

        setCaptchaEuScript();

        handleCloseDropdownOnBlur('.new-input__dropdown-container--contact');
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        handleIsBrandstoreSelected() {
            this.isNoBrandstoreSelected = !this.isNoBrandstoreSelected;
        },

        handleCompanyNameRequiredLabel(requestTypeValue) {
            const labelCompany = document.getElementById('label-company');
            if (!labelCompany) return;

            const labelCompanyInnerText = labelCompany.innerText;

            if (requestTypeValue === 'business') {
                labelCompany.innerText = `${labelCompanyInnerText} *`;
                return;
            }

            labelCompany.innerText = labelCompanyInnerText.replace(' *', '');
        },

        handleToggleButtonActiveClass(index) {
            return this.requestIndex === index ? 'checked' : '';
        },

        handleToggleBrandstoreSearchVisibility(value) {
            const isShowOnSweden =
                this.countryHandle == 'mgMotorsSweden' &&
                value !== 'other-requests';

            const isShownForNoValue =
                this.countryHandle === 'mgMotorsNorway' ||
                this.countryHandle === 'mgMotorsNetherlands' ||
                this.countryHandle === 'mgMotorsSpain';

            const isShownOnFrance =
                this.countryHandle === 'mgMotorsFrance' &&
                (value === 'aftersales-service' || value === 'accessories');

            const isShownOnPortugal =
                this.countryHandle === 'mgMotorsPortugal' &&
                value !== 'marketing-advertising';

            const isShownOnFinland = this.countryHandle === 'mgMotorsFinland';

            return (
                (value.length && value === 'want-contact-from-dealer') ||
                isShowOnSweden ||
                isShownOnPortugal ||
                isShownForNoValue ||
                isShownOnFrance ||
                isShownOnFinland
            );
        },

        handleMarketingConsentChange(e) {
            e.preventDefault();
            const isConsentChecked = e.target.checked;
            const hiddenMarketingInput = document.querySelector('#marketing');
            if (!hiddenMarketingInput) return;
            hiddenMarketingInput.setAttribute(
                'value',
                isConsentChecked ? '1' : '0',
            );
        },

        scrollToFirstError() {
            Vue.nextTick(() => {
                let firstError = document.querySelector(
                    '.new-input__container--error',
                );
                zenscroll.center(firstError);
            });
        },

        scrollToTop() {
            Vue.nextTick(() => {
                zenscroll.toY(0);
            });
        },

        async onSubmit(event) {
            event.preventDefault();
            const form = event.currentTarget;
            let formData = new FormData(form);
            const data = {};

            for (let [key, val] of formData.entries()) {
                Object.assign(data, { [key]: val });
            }

            if (this.submitting) return;

            this.submitting = true;

            const contactDataLayer = {
                event: 'contact',
                brandStore: this.selectedBrandStore
                    ? this.selectedBrandStore.title
                    : '',
                user_data: {
                    email_address: data.emailAddress,
                    phone_number: data.phone,
                    address: {
                        first_name: data.firstName,
                        last_name: data.lastName,
                        city: data.city,
                        postal_code: data.postalCode,
                    },
                },
            };

            if (!this.isNumberValid) {
                this.submitting = false;
                return;
            }

            try {
                if (!this.isCaptchaEuEnabled) {
                    await this.handleDataSubmit(form, contactDataLayer);
                    return;
                }

                const captchaSolution = await KROT.getSolution(
                    this.captchaEuPublicKey,
                );

                await this.handleDataSubmit(
                    form,
                    contactDataLayer,
                    captchaSolution,
                );
            } catch (e) {
                throw new Error(e);
            } finally {
                this.submitting = false;
            }
        },

        async handleDataSubmit(form, contactDataLayer, captchaSolution) {
            try {
                const formData = new FormData(form);
                if (captchaSolution) {
                    formData.append(
                        'captchaSolution',
                        JSON.stringify(captchaSolution),
                    );
                }
                const { data } = await axios.post('/', formData);
                const result = data;

                if (result.data.errors) {
                    this.submitting = false;
                    this.errors.clear();
                    this.errors.record(result.data.errors);

                    this.scrollToFirstError();
                    return;
                }

                this.errors.clear();
                this.isNumberValid = true;

                // Only Benelux countries
                if (
                    this.siteHandle === 'mgMotorsBelgiumNl' ||
                    this.siteHandle === 'mgMotorsBelgiumFr'
                ) {
                    window.__ss_noform.push([
                        'submit',
                        null,
                        this.sharpspringEndpointId,
                    ]);
                }

                this.sendGTMData(contactDataLayer);

                window.location = this.$refs.redirectUrl.value;
            } catch (e) {
                throw new Error(e);
            }
        },

        sendGTMData(extraDataToPush) {
            const country =
                this.siteHandle == 'default'
                    ? 'mgMotorsEurope'
                    : this.siteHandle;

            if (checkCCM19Consent() || checkOneTrustConsent()) {
                // check if you are on production-enviroment
                if (!window.dataLayer) {
                    window.dataLayer = window.dataLayer || [];
                }

                if (extraDataToPush) {
                    window.dataLayer.push(extraDataToPush);
                }

                window.dataLayer.push({
                    event: 'contacts',
                    model: ' ',
                    edition: ' ',
                    page_path: window.location.href,
                    country: `${country} - ${this.$root.languageCode}`,
                });
            }
        },

        toggleDropdown(event) {
            event.preventDefault();
            let element = event.currentTarget;

            while ((element = element.parentElement)) {
                if (element.classList.contains('dropdown')) {
                    element.classList.toggle('dropdown--active');
                }
            }
        },

        handleSetCountryHandleByDropdown(targetValue) {
            const frDropdownCountry = [
                'guyane',
                'guadeloupe',
                'martinique',
                'mayotte',
                'reunion',
            ];
            const isTargetValueFrCountry =
                frDropdownCountry.includes(targetValue);

            if (isTargetValueFrCountry) {
                this.countryHandle = 'mgMotorsFrance';
                return;
            }

            this.countryHandle = targetValue;
        },

        setDropdownCountry(event) {
            event.preventDefault();
            this.toggleDropdown(event);

            this.dropdownCountry = event.currentTarget.dataset.text;
            this.countryHandle = event.currentTarget.dataset.value;
            this.internalCountryHandle = event.currentTarget.dataset.dorm;

            this.dropdownSubject = null;
            this.isVinNumberVisible = false;

            this.handleSetCountryHandleByDropdown(
                event.currentTarget.dataset.value,
            );

            const territory = event.currentTarget.dataset.dorm;
            if (
                ['guyane', 'guadeloupe', 'martinique', 'mayotte'].includes(
                    territory,
                )
            ) {
                this.internalCountryHandle = territory;
                this.frBrandStoreHandle = territory;
                this.dropdownFrStore = JSON.stringify({
                    title: this.frBrandStores[territory],
                });

                this.dropdownFrStoreValue = this.frBrandStores[territory];

                return;
            }

            if (territory === 'reunion') {
                this.internalCountryHandle = territory;
                this.frBrandStoreHandle = 'MG Saint-Pierre (97 410)';
                this.dropdownFrStore = JSON.stringify({
                    title: 'MG Saint-Pierre (97 410)',
                });
                this.dropdownFrStoreValue = 'MG Saint-Pierre (97 410)';
            }

            if (territory === 'france') {
                this.dropdownFrStore = '';
                this.dropdownFrStoreValue = '';
            }

            if (this.ceeCountries.includes(this.dropdownCountry)) {
                this.isCeeCountrySelected = true;
            }
        },

        setDropdownFrBrandStore(event) {
            event.preventDefault();
            const text = event.currentTarget.dataset.text;
            this.dropdownFrStore = JSON.stringify({ title: text });
            this.dropdownFrStoreValue = text;

            this.frBrandStoreHandle = event.currentTarget.dataset.value;

            this.toggleDropdown(event);
        },

        setDropdownSubject(event) {
            event.preventDefault();
            this.dropdownSubject = event.currentTarget.dataset.text;
            this.toggleDropdown(event);

            const value = event.currentTarget.dataset.value;
            this.selected = value;
        },
    },
});
